import { createWebHistory } from "vue-router";
import { createLangRouter } from "vue-lang-router";
import translations from "@/lang/translations";
import localizedURLs from "@/lang/localized-urls";

import HomeView from "@/views/HomeView.vue";

import CartasView from "@/views/cartas/CartasView.vue";
import CartaPresidenteView from "@/views/cartas/CartaPresidenteView.vue";
import CartaDirectorView from "@/views/cartas/CartaDirectorView.vue";

import PlanEstrategicoView from "@/views/planestrategico/PlanEstrategicoView.vue";

import EnResumenView from "@/views/actuacion/EnResumenView.vue";
import ActuacionView from "@/views/actuacion/ActuacionView.vue";
import AsistenciaPersonalizadaView from "@/views/actuacion/AsistenciaPersonalizadaView.vue";
import AccionesPrevencionView from "@/views/actuacion/AccionesPrevencionView.vue";
import TecnologiaPersonasView from "@/views/actuacion/TecnologiaPersonasView.vue";
import OrganizacionView from "@/views/actuacion/OrganizacionView.vue";

import SostenibilidadView from "@/views/sostenibilidad/SostenibilidadView.vue";
import NuevoPlanView from "@/views/sostenibilidad/NuevoPlanView.vue";
import NuestraContribucionView from "@/views/sostenibilidad/NuestraContribucionView.vue";
import AccionesView from "@/views/sostenibilidad/AccionesView.vue";

import PageNotFound from '@/views/PageNotFound.vue';


const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView
  },
  {
    path: "/cartas",
    name: "cartas",
    component: CartasView,
    children: [
      {
        path: "carta-del-presidente",
        name: "carta-del-presidente",
        component: CartaPresidenteView
      },
      {
        path: "carta-del-director-gerente",
        name: "carta-del-director-gerente",
        component: CartaDirectorView
      }
    ]
  },
  {
    path: "/plan-estrategico",
    name: "plan-estrategico",
    component: PlanEstrategicoView
  },
  {
    path: "/nuestra-actuacion-en-2021",
    name: "nuestra-actuacion-en-2021",
    component: ActuacionView,
    children: [

      {
        path: "2021-en-resumen",
        name: "2021-en-resumen",
        component: EnResumenView
      },
      {
        path: "asistencia-sanitaria-personalizada",
        name: "asistencia-sanitaria-personalizada",
        component: AsistenciaPersonalizadaView
      },
      {
        path: "acciones-de-prevencion",
        name: "acciones-de-prevencion",
        component: AccionesPrevencionView
      },
      {
        path: "tecnologia-al-servicio-de-las-personas",
        name: "tecnologia-al-servicio-de-las-personas",
        component: TecnologiaPersonasView
      },
      {
        path: "organizacion-y-buen-gobierno",
        name: "organizacion-y-buen-gobierno",
        component: OrganizacionView
      }
    ]
  },
  {
    path: "/sostenibilidad",
    name: "sostenibilidad",
    component: SostenibilidadView,
      children: [
      {
        path: "plan-de-rsc-y-sostenibilidad-21-24",
        name: "plan-de-rsc-y-sostenibilidad-21-24",
        component: NuevoPlanView
      },
      {
        path: "nuestra-contribucion-a-los-ods",
        name: "nuestra-contribucion-a-los-ods",
        component: NuestraContribucionView
      },
      {
        path: "impacto-en-el-entorno",
        name: "impacto-en-el-entorno",
        component: AccionesView
      }
    ]
  },
  {
    path: "/:pathMatch(.*)*",
    name: "not-found",
    component: PageNotFound,
  }
];

// Initiate router
const langRouterOptions = {
  defaultLanguage: "es",
  translations,
  localizedURLs
};
const routerOptions = {
  routes,
  history: createWebHistory('/export/2021/'),
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
      behavior: 'instant',
    }
  }
};

const router = createLangRouter(langRouterOptions, routerOptions);

export default router;
